import React from 'react';

const ErrorPage = () => {
    return (
        <h1 className='error__page h-[92dvh]'>ERROR 404: page not found</h1>
    );
};

export default ErrorPage;